import React, {useState, useEffect} from 'react';
import {Container, Row} from 'reactstrap';
import Phone from '../../Constans/Phone';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import PopUp from 'app/Components/Shared/Popup/PopUp';
import PhoneUpgradeUnavailable from '../../PopUps/PhoneUpgradeUnavailable';
function DeviceProcess(props) {
  const [showPopup, setShowPopup] = useState(false);
  useEffect(() => {
    props.setSelectedPhone(null);
  }, []);

  function handlePhoneClick(phone) {
    if (props.userType === 'Senior') {
      setShowPopup(true);
    } else {
      props.setSelectedPhone(phone);
    }
  }
  function onClickPackageType(type) {
    props.setSelectedPhone(null);
    props.setIsLeasing(type);
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // You can use 'auto' for instant scrolling
    });
  }
  function getPhones() {
    return (
      <div className='phones-container'>
        {props.data &&
          props.data.map((phone) => (
            <Phone phone={phone} isLeasing={props.isLeasing} onClick={handlePhoneClick} selectedPhone={props.selectedPhone}></Phone>
          ))}
      </div>
    );
  }
  return (
    <div className='device-sim-process'>
      <Container fluid className='idf-step-header justify-content-center d-flex flex-column align-items-center text-center'>
        <Row className='idf-line justify-content-center d-flex'></Row>
        <Row className='idf-title-bold justify-content-center d-flex'>מגוון ענק של מכשירים במחירים מיוחדים רק בשבילך</Row>
        <Row className='idf-title-marketing-regular justify-content-center d-flex'>בחרו מכשיר לקבלת מידע וביצוע פעולות</Row>
      </Container>
      {getPhones()}
      {props.userType != 'Senior' && (
        <BtnWhiteBlackBorderBigSize
          text={!props.isLeasing ? 'לצפייה במכשירים במסלול ליסינג' : 'לצפייה במכשירים במסלול רגיל '}
          onclick={() => onClickPackageType(!props.isLeasing ? true : false)}
        />
      )}
      <PopUp className='phone-upgrade-unavailable' preventWrapperClose={true} showPopUp={showPopup} onClose={() => setShowPopup(false)}>
        <PhoneUpgradeUnavailable setShowPopUp={setShowPopup} contentData={props.contentData} />
      </PopUp>
    </div>
  );
}

export default DeviceProcess;
